const reviewsButton = document.getElementById("drawer-menu-reviews");
const targetNode = document.getElementById('drawer-menu-buttons-wrapper');

if (reviewsButton) {
  const averageRatingElement = reviewsButton.querySelector(".drawer-menu__average-rating");
  const allReviewsElement = reviewsButton.querySelector(".drawer-menu__reviews-count");

  const observer = new MutationObserver(() => {
    const okendoStarsWidget = document.querySelector(
      '[data-oke-reviews-group-id="a62cd613-caed-4d57-a7ac-74c0bc15fb9b"]'
    );

    if (!okendoStarsWidget) return;

    const okendoRatingEl = okendoStarsWidget.querySelector(".oke-sr-rating");
    const okendoReviewsCountEl = okendoStarsWidget.querySelector(".oke-sr-count-number");

    if (okendoRatingEl && okendoReviewsCountEl && averageRatingElement && allReviewsElement) {
      const averageRating = okendoRatingEl.textContent.trim();
      const reviewsCount = okendoReviewsCountEl.textContent.trim();

      averageRatingElement.textContent = `${averageRating} out of 5`;
      allReviewsElement.textContent = `Based on ${reviewsCount} reviews`;

      observer.disconnect();
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
} else {
  console.warn('Element with ID "drawer-menu-reviews" not found');
}
